export default "__VITE_ASSET__BSvGwaHn__"